import { GuidePages } from '../pages/GuidePages/GuidePages';
import { StripperPages } from '../pages/StripperPages/StripperPages';
import { ServiceProviderPages } from '../pages/ServiceProviderPages/ServiceProviderPages';
import {SalesPartnerPages} from "../pages/SalesPartnerPages/SalesPartnerPages";
import {AccommodationProviderPages} from "../pages/AccommodationProviderPages/AccommodationProviderPages";

export const PAGES = {
  GUIDE: GuidePages,
  EVENT_STAFF: StripperPages,
  BOOKING_MANAGER: ServiceProviderPages,
  ACCOMMODATION_BOOKING_MANAGER: AccommodationProviderPages,
  SALES_PARTNER: SalesPartnerPages,
};